// extracted by mini-css-extract-plugin
module.exports = {"BlockData":"styles-module--BlockData--1VYRc","number":"styles-module--number--1ceES","activity":"styles-module--activity--1kNUb","container":"styles-module--container--37PBa"};